/**
 * Indigo -> violet gradient. Layered cards representing a collection of lessons.
 * Solid-fill dual-layer construction matching StreakFlame visual style.
 */

import { type EmblemProps } from './types';

export function CourseCap({ size = 36, className = '' }: EmblemProps) {
  return (
    <div className={`relative shrink-0 ${className}`} style={{ width: size, height: size }}>
      {/* Glow */}
      <svg
        width={size}
        height={size}
        viewBox="0 0 48 48"
        fill="none"
        className="absolute inset-0"
        style={{ filter: 'blur(4px)', opacity: 0.35 }}
      >
        <rect x="6" y="8" width="30" height="36" rx="5" fill="url(#f-stack-glow)" />
        <defs>
          <linearGradient
            id="f-stack-glow"
            x1="20"
            y1="6"
            x2="28"
            y2="44"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FF9B4A" />
            <stop offset="0.55" stopColor="#FF6EB1" />
            <stop offset="1" stopColor="#8A6CF0" />
          </linearGradient>
        </defs>
      </svg>

      {/* Main stack */}
      <svg
        width={size}
        height={size}
        viewBox="0 0 48 48"
        fill="none"
        className="relative animate-breathe"
      >
        <defs>
          <linearGradient
            id="f-stack-main"
            x1="20"
            y1="4"
            x2="28"
            y2="44"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FF9B4A" />
            <stop offset="0.55" stopColor="#FF6EB1" />
            <stop offset="1" stopColor="#8A6CF0" />
          </linearGradient>
          <linearGradient
            id="f-stack-inner"
            x1="20"
            y1="12"
            x2="26"
            y2="40"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#ffe4d0" />
            <stop offset="1" stopColor="#8A6CF0" />
          </linearGradient>
        </defs>
        {/* Back card */}
        <rect x="14" y="4" width="28" height="36" rx="5" fill="url(#f-stack-main)" opacity="0.3" />
        {/* Middle card */}
        <rect x="10" y="8" width="28" height="36" rx="5" fill="url(#f-stack-main)" opacity="0.55" />
        {/* Front card -- full solid fill */}
        <rect x="6" y="12" width="28" height="36" rx="5" fill="url(#f-stack-main)" />
        {/* Inner highlight on front card -- depth layer */}
        <rect
          x="10"
          y="16"
          width="20"
          height="28"
          rx="3"
          fill="url(#f-stack-inner)"
          opacity="0.35"
        />
      </svg>
    </div>
  );
}
